import React from 'react';
import { ShoppingCartIcon } from 'lucide-react';
export function Hero() {
  return <section className="py-20 md:py-32 bg-cover bg-center bg-no-repeat relative" style={{
    backgroundImage: "url('https://cdn.magicpatterns.com/uploads/vXXapbap4G9yMV7jeyuNr6/E-commerce-Website-Solutions.png')"
  }} data-id="element-458">
      <div className="absolute inset-0 bg-gradient-to-b from-header/40 via-primary/30 to-primary/50" data-id="element-459" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-460">
        <div className="text-center" data-id="element-461">
          <div className="w-16 h-16 bg-white/10 border border-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mx-auto mb-6 load-fade-in-up stagger-1" data-id="element-462">
            <ShoppingCartIcon className="w-8 h-8 text-white" data-id="element-463" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 load-fade-in-up stagger-2" data-id="element-464">
            E-Commerce Solutions
          </h1>
          <p className="text-xl text-blue-200 leading-relaxed load-fade-in-up stagger-3" data-id="element-465">
            Custom-built online stores designed to convert — not just exist.
            From storefront design and payment processing to inventory
            management and tax automation, we deliver end-to-end e-commerce
            platforms with zero transaction fees and full ownership of your
            data.
          </p>
        </div>
      </div>
    </section>;
}